import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _QualityGarment, _Technicians } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectQualityGarment = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityGarment);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        getLista();
    }, []);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDQualityGarment === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDQualityGarment,
                    label: `${found.DataBeanProperties.CodeGarment} - ${found.DataBeanProperties.Name}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        const props = {
            State: 1,
        }
        instance.getQualityGarmentCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDQualityGarment,
        label: `${item.DataBeanProperties.CodeGarment} - ${item.DataBeanProperties.Name}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Prenda"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona una Prenda..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
